<table class="gup-C-table__basic">

    <!-- Headers -->
    <thead>
    <tr>
        <th *ngFor="let columnsHeader of displayedColumns"
            [class]="'column-' + columnsHeader">{{columns[columnsHeader]}}
        </th>
        <th>
            <!-- colonne action -->
        </th>
    </tr>
    </thead>

    <!-- content   -->
    <ng-container *ngFor="let ruleForm of ruleLineFormGroupList; index as index">
        <!-- rule line-->
        <tr [formGroup]="ruleForm">
            <td *ngFor="let columnsHeader of displayedColumns" [class]="'column-' + columnsHeader"
                [ngSwitch]="columnsHeader">

                <ng-container *ngSwitchCase="'IdOperateur'">
                    <kal-form-field *ngIf="ruleForm.get('IdOperateur').value || index !== 0"
                                    class="without-label gup-C-formFieldSize--bottomNull">
                        <kal-select formControlName="IdOperateur">
                            <kal-option *ngIf="index === 0" [value]="null">
                                Aucun
                            </kal-option>
                            <kal-option *ngFor="let operator of logicOperatorList" [value]="operator.Id">
                                {{operator.Libelle}}
                            </kal-option>
                        </kal-select>
                    </kal-form-field>

                </ng-container>

                <ng-container *ngSwitchCase="'ParentheseOuvrante'">
                    <kal-input formControlName="ParentheseOuvrante"></kal-input>
                </ng-container>

                <ng-container *ngSwitchCase="'IdCritere'">
                    <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">
                        <kal-select formControlName="IdCritere"
                                    placeholder="Sélectionner un critère"
                                    displaySearchbar>
                            <kal-option *ngFor="let criterion of criteriaList" [value]="criterion.Id" [class.gup-U-red]="criterion.PossedeDesParametres">
                                {{criterion.Libelle}}
                            </kal-option>
                        </kal-select>
                    </kal-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'Valeur'">
                    <ng-template #advancedComputingTemplate>
                        <kal-button (click)="openAdvancedComputing(ruleForm, 'Valeur', 'ListeCalculs')"
                                    [disabled]="ruleFormArray.disabled"
                                    kalTheme="tertiary">Calcul avancé
                        </kal-button>
                    </ng-template>

                    <div *ngIf="!ruleForm.get('ListeCalculs').value; else advancedComputingTemplate"
                         class="flexLine-table">

                        <app-shared-advanced-rule-criterion-value-control
                            [criterionId]="ruleForm.get('IdCritere').value"
                            formControlName="Valeur">
                        </app-shared-advanced-rule-criterion-value-control>

                        <kal-button
                            (click)="openAdvancedComputing(ruleForm, 'Valeur', 'ListeCalculs')"
                            *ngIf="(ruleForm.get('IdCritere').value | isNumberCriterion : criteriaList) && ruleFormArray.enabled"
                            kalTheme="tertiary">
                            +
                        </kal-button>

                    </div>

                </ng-container>

                <ng-container *ngSwitchCase="'Subvention'">
                    <ng-container
                        *ngTemplateOutlet="valueOrAdvancedComputationTemplate; context: {controlName: 'Subvention', listControlName: 'ListeCalculsSubvention'}"></ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'SubventionDefaut'">
                    <ng-container
                        *ngTemplateOutlet="valueOrAdvancedComputationTemplate; context: {controlName: 'SubventionDefaut', listControlName: 'ListeCalculsSubventionDefaut'}"></ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'IdOperateurMolecule'">
                    <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">
                        <kal-select formControlName="IdOperateurMolecule">
                            <kal-option
                                *ngFor="let operator of comparisonOperatorList | filteredComparisonOperatorList : ( criteriaList | isEqualOperator:ruleForm.value.IdCritere ) "
                                [value]="operator.Id">
                                {{operator.Libelle}}
                            </kal-option>
                        </kal-select>
                    </kal-form-field>
                </ng-container>

                <ng-container *ngSwitchDefault>
                    <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">
                        {{ruleForm.value?.[columnsHeader]}}
                    </kal-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'ParentheseFermante'">
                    <kal-input formControlName="ParentheseFermante"></kal-input>
                </ng-container>


                <ng-container *ngSwitchCase="'SubventionGroupe'">
                    <ng-container
                        *ngTemplateOutlet="valueOrAdvancedComputationTemplate; context: {controlName: 'SubventionGroupe', listControlName: 'ListeCalculsSubventionGroupe'}"></ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'SubventionDefautGroupe'">
                    <ng-container
                        *ngTemplateOutlet="valueOrAdvancedComputationTemplate; context: {controlName: 'SubventionDefautGroupe', listControlName: 'ListeCalculsSubventionDefautGroupe'}"></ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'IdRegleApplication'">
                    <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">
                        <kal-select formControlName="IdRegleApplication">
                            <kal-option [value]="null">Aucun</kal-option>
                            <kal-option *ngFor="let rule of applicationRuleList" [value]="rule.Id">
                                {{rule.Valeur}}
                            </kal-option>
                        </kal-select>
                    </kal-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'IdRegleNonApplication'">
                    <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">
                        <kal-select formControlName="IdRegleNonApplication">
                            <kal-option [value]="null">Aucun</kal-option>
                            <kal-option *ngFor="let rule of applicationRuleList" [value]="rule.Id">
                                {{rule.Valeur}}
                            </kal-option>
                        </kal-select>
                    </kal-form-field>
                </ng-container>

                <ng-container *ngSwitchCase="'IdTypeDate'">
                    <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">
                        <kal-select formControlName="IdTypeDate">
                            <kal-option [value]="0">Aucun</kal-option>
                            <kal-option *ngFor="let date of dateTypeList" [value]="date.Id">
                                {{date.Libelle}}
                            </kal-option>
                        </kal-select>

                        <ng-container *ngIf="ruleForm.get('IdTypeDate').value | needDaysInMonthFormId : dateTypeList">
                            <app-shared-days-in-month-edit formControlName="JourDuMois"></app-shared-days-in-month-edit>
                        </ng-container>
                    </kal-form-field>

                </ng-container>

                <ng-template #valueOrAdvancedComputationTemplate let-controlName="controlName"
                             let-listControlName="listControlName">

                    <ng-template #advancedComputingTemplate>
                        <kal-button (click)="openAdvancedComputing(ruleForm, controlName, listControlName)"
                                    [disabled]="ruleFormArray.disabled"
                                    kalTheme="tertiary">
                            Calcul avancé
                        </kal-button>
                    </ng-template>

                    <div *ngIf="!ruleForm.get(listControlName).value; else advancedComputingTemplate"
                         class="flexLine-table">

                        <kal-form-field class="without-label gup-C-formFieldSize--bottomNull">
                            <kal-input [formControlName]="controlName"
                                       type="number"></kal-input>
                        </kal-form-field>

                        <kal-button *ngIf="ruleFormArray.enabled"
                                    (click)="openAdvancedComputing(ruleForm, controlName, listControlName)"
                                    kalTheme="tertiary">
                            +
                        </kal-button>

                    </div>

                </ng-template>

            </td>

            <td class="column-kal-action">
                <div>
                    <kal-button [disabled]="ruleFormArray.disabled" [kalMenuTriggerFor]="actionsMenu"
                                kalTheme="tertiary">
                        <kal-icon>more_horiz</kal-icon>
                    </kal-button>

                    <kal-menu #actionsMenu>
                        <kal-option (selectionChange)="removeRule(index)">Supprimer</kal-option>
                        <kal-option (selectionChange)="duplicate(index)">Dupliquer</kal-option>
                        <kal-option (selectionChange)="moveDown(index)" *ngIf="index !== ruleFormArray.length -1">
                            Descendre
                            la ligne
                        </kal-option>
                        <kal-option (selectionChange)="moveUp(index)" *ngIf="index !== 0">Monter la ligne</kal-option>
                    </kal-menu>
                </div>
            </td>

        </tr>

        <!-- show parameters -->
        <tr *ngIf="hasParameters(ruleForm.get('IdCritere').value)" [formGroup]="ruleForm">

            <td colspan="20">

                <div>
                    Paramètre pour le critère
                    {{(ruleForm.get('IdCritere').value | findCriterionById : criteriaList)?.Libelle}}
                    <span (click)="showParametersCriteria(ruleForm.get('NewGuid').value)">
                        <kal-icon class="mat-icon-rtl-mirror">
                            {{getIsOpenValue(ruleForm) ? 'expand_more' : 'expand_less'}}
                        </kal-icon>
                    </span>
                </div>

                <div>
                    <kal-expansion-panel-content *ngIf="getIsOpenValue(ruleForm)">
                        <app-shared-advanced-rule-criterion-parameters-control
                            [criterionId]="ruleForm.get('IdCritere').value"
                            formControlName="Parametres">
                        </app-shared-advanced-rule-criterion-parameters-control>
                    </kal-expansion-panel-content>
                </div>
        </tr>
    </ng-container>

</table>

<ul *ngIf="ruleFormArray.errors">
    <li *ngFor="let errorMessage of getErrorMessages(ruleFormArray.errors)" class="gup-O-msg -error">
        {{ errorMessage }}
    </li>
</ul>

<app-shared-icon-button (click)="addRule()" *ngIf="ruleFormArray.enabled"
                        class="gup-U-margin-bottom--small gup-U-margin-top--small">Ajouter une ligne
</app-shared-icon-button>
